var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',_vm._g(_vm._b({class:_vm.classes,style:(_vm.styles),attrs:{"tag":_vm.tag}},'Box',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }